// Mife Sales AI — self-contained tri-language copy.
// Kept inline (no global i18n bloat) because German is currently scoped only
// to the Sales module marketing/onboarding surface.

export const SALES_COPY = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      pricing: 'Fiyatlandırma',
      lifeAssistant: 'Yaşam Asistanı',
      salesAi: 'Sales AI',
      login: 'Giriş Yap',
      cta: 'Müşteri Bulmaya Başla',
    },
    landing: {
      eyebrow: 'AI Sales Assistant',
      h1Pre: 'Mife sana',
      h1Highlight: 'iletişime hazır şirketleri',
      h1Post: 'verir — AI de satış yazışmasını yapar.',
      sub: 'Kendi lead listeni bulmak zorunda değilsin. Mife’ın hazır veri tabanından sektör ve ülke seç, uygun şirketleri seç, AI senin adına kişisel e-posta yazar.',
      ctaPrimary: 'Müşteri Bulmaya Başla',
      ctaSecondary: 'Fiyatlandırmayı Gör',
      trust: 'Ücretsiz başla · Kredi kartı yok · İstediğin zaman iptal',
      featuresTitle: 'Üç adımda satış pipeline’ı',
      f1Title: '1 — Hedef pazarını seç',
      f1Body: 'Sektör, ülke ve opsiyonel olarak şehir. Mife’ın veri tabanında sana uygun şirketleri görürsün.',
      f2Title: '2 — Şirketleri seç',
      f2Body: 'Uygun gördüğün kişilerin kilidini aç. E-posta adresi ve detaylar görünür olur.',
      f3Title: '3 — AI yazar, sen gönderirsin',
      f3Body: 'Her seçtiğin kişi için 3 kişisel e-posta varyasyonu üretilir. Gönderim sonraki adımda kendi Gmail’inden çıkar.',
      whyTitle: 'Neden Mife Sales AI?',
      why: [
        { t: 'Veri tabanı hazır', d: 'Kendi lead\'ini bulmakla uğraşma. Mife senin için binlerce B2B kişiyi tek panelde sunar.' },
        { t: 'Tek araç, 3 dil', d: 'Türkçe, İngilizce ve Almanca outbound mesajları aynı panelden üret.' },
        { t: 'Kendi domain’in', d: 'Gönderim kendi Gmail/Workspace hesabından. Marka güveni sende.' },
        { t: 'Spam değil sistem', d: 'Günlük gönderim limiti, AI kişiselleştirme ve aralarda bekleme süresi otomatik.' },
      ],
      complianceTitle: 'GDPR-uyumlu yapı',
      complianceBody:
        'E-postalar senin Gmail hesabından gönderilir. Mife yalnızca tool sağlar — kullanıcı verileri AB sunucularında saklanır, üçüncü taraflara satılmaz, harici modeller eğitmek için kullanılmaz.',
      bottomCtaTitle: 'Bugün doğru 10 şirketi Mife’tan seç.',
      bottomCtaBody: 'Onboarding 2 dakika. İlk kişiselleştirilmiş e-postalar 5 dakikada çıkar.',
    },
    onboarding: {
      title: 'Sales AI Onboarding',
      sub: '3 soruda hedef pazarına en uygun şirketleri sıralayalım.',
      whatYouSell: 'Ne satıyorsun?',
      whatYouSellHelp: 'Tek cümleyle ürününü/hizmetini özetle.',
      audience: 'Hedef kitle',
      audienceHelp: 'Kim alıyor? Rol, şirket büyüklüğü, ihtiyaç.',
      industry: 'Hedef sektör',
      country: 'Hedef ülke',
      city: 'Hedef şehir (opsiyonel)',
      website: 'Web siten (opsiyonel)',
      meetingLink: 'Görüşme linki (Calendly vb. — opsiyonel)',
      submit: 'Kaydet ve şirketleri gör',
      success: 'Profil kaydedildi. Uygun şirketler getiriliyor…',
      selectOption: 'Seç…',
    },
    discover: {
      title: 'Sana uygun şirketler',
      sub: 'Mife veri tabanındaki {count} şirket senin kriterlerine uyuyor. Açtıkça e-posta ve detaylar görünür.',
      filterIndustry: 'Sektör',
      filterCountry: 'Ülke',
      filterCity: 'Şehir',
      filterApply: 'Filtrele',
      filterClear: 'Temizle',
      colCompany: 'Şirket',
      colContact: 'Kişi',
      colLocation: 'Konum',
      colSize: 'Büyüklük',
      colAction: 'İşlem',
      reveal: 'Kişiyi Aç',
      revealed: 'Açıldı',
      selected: 'Seçildi',
      emptyTitle: 'Tam eşleşme bulamadık',
      emptyBody: 'İşte keşfedebileceğin benzer şirketler:',
      openDashboard: 'Kampanyam',
      previewBanner: 'Ücretsiz planda 5 kişi önizliyorsun. Yükselt → sınırsız keşif.',
    },
    dashboard: {
      title: 'Kampanyam',
      sub: 'Açtığın şirketler ve durumları.',
      contactsRemaining: 'Kalan kişi',
      emailsRemaining: 'Kalan AI maili',
      icpBox: 'AI Ideal Customer Profile',
      icpEmpty: 'Henüz ICP üretilmedi.',
      icpGenerate: 'ICP Üret',
      icpRegenerate: 'Yeniden Üret',
      goDiscover: 'Yeni şirket bul',
      leadsTitle: 'Seçtiğin şirketler',
      leadsEmpty: 'Henüz şirket seçmedin. “Yeni şirket bul”a tıkla.',
      colCompany: 'Şirket',
      colContact: 'Kişi',
      colStatus: 'Durum',
      colActions: 'İşlem',
      genEmails: 'AI Mail Üret',
      view: 'Gör',
      delete: 'Sil',
      statusOptions: {
        selected: 'Seçildi',
        draft_ready: 'E-posta hazır',
        contacted: 'İletişim kuruldu',
        replied: 'Yanıtladı',
        meeting: 'Toplantı',
      },
      drafts: 'AI E-posta Taslakları',
      noDrafts: 'Henüz taslak yok. “AI Mail Üret” ile başlat.',
      copy: 'Kopyala',
      upgrade: 'Planı Yükselt',
      urgency: 'Sınırlı ücretsiz kullanım — devam etmek için yükselt.',
    },
    pricing: {
      h1: 'Sürekli stratejik zeka.',
      sub: 'Tek seferlik bir rapor değil — şirketinin nasıl evrildiğini takip eden operasyonel zeka aboneliği. İstediğin zaman iptal.',
      mostPopular: 'En çok seçilen',
      perMonth: '/ay',
      free:    { name: 'Free',    price: '₺0',    tagline: 'İlk tanını çalıştırmak için.' },
      starter: { name: 'Starter', price: '₺999',  tagline: 'Büyüme darboğazlarına görünürlük inşa eden operatörler için.' },
      pro:     { name: 'Pro',     price: '₺2.999', tagline: 'Sürekli operasyonel yeniden değerlendirme yapan ekipler için.' },
      cta: 'Planı seç',
      ctaCurrent: 'Mevcut plan',
      footnote: 'KVKK / GDPR uyumlu. Verin sende kalır. İstediğin zaman iptal.',
      legal: 'Gizlilik · Kullanım Şartları · Künye · DPA',
    },
    paywall: {
      title: 'Ücretsiz limitine ulaştın.',
      body: 'Devam etmek için yükselt:',
      bullet1: 'Sınırsız şirket keşfi',
      bullet2: 'Tam kişi erişimi',
      bullet3: 'AI ile outbound mailler',
      cta: 'Şimdi Yükselt',
      cancel: 'Şimdi değil',
      socialProof: 'Kurucular, ajanslar ve satış ekipleri için tasarlandı.',
      weeklyProof: 'Lead bul, outreach üret, daha hızlı kapat',
    },
  },
  en: {
    nav: {
      home: 'Home',
      pricing: 'Pricing',
      lifeAssistant: 'Life Assistant',
      salesAi: 'Sales AI',
      login: 'Log in',
      cta: 'Start Finding Clients',
    },
    landing: {
      eyebrow: 'AI Sales Assistant',
      h1Pre: 'Mife gives you',
      h1Highlight: 'ready-to-contact companies',
      h1Post: '— AI handles the outreach.',
      sub: 'You don\'t need to bring your own leads. Pick an industry and market, choose the companies you like from Mife\'s curated database, and AI writes personalised emails on your behalf.',
      ctaPrimary: 'Start Finding Clients',
      ctaSecondary: 'See Pricing',
      trust: 'Start free · No credit card · Cancel anytime',
      featuresTitle: 'A sales pipeline in three steps',
      f1Title: '1 — Pick your target market',
      f1Body: 'Industry, country, optional city. Matching companies surface instantly from Mife\'s database.',
      f2Title: '2 — Unlock the companies you want',
      f2Body: 'Unlock any contact you like. Email and full details become visible.',
      f3Title: '3 — AI writes, you send',
      f3Body: 'Three personalised email variants per contact. Sending happens from your own Gmail in the next step.',
      whyTitle: 'Why Mife Sales AI?',
      why: [
        { t: 'Database already built', d: 'No more chasing lists. Mife surfaces thousands of B2B contacts in a single console.' },
        { t: 'One tool, 3 languages', d: 'Generate outbound messages in Turkish, English and German from the same console.' },
        { t: 'Your own domain', d: 'Sending happens from your Gmail/Workspace. The brand trust stays with you.' },
        { t: 'A system, not spam', d: 'Daily send limits, AI personalisation and inter-send delays are baked in.' },
      ],
      complianceTitle: 'GDPR-safe by design',
      complianceBody:
        'Emails are sent from your own Gmail account. Mife only provides tooling — your data stays on EU servers, is never sold and is never used to train external models.',
      bottomCtaTitle: 'Pick your first 10 companies from Mife today.',
      bottomCtaBody: 'Onboarding takes 2 minutes. First personalised emails ready in 5.',
    },
    onboarding: {
      title: 'Sales AI Onboarding',
      sub: 'Three quick questions and your matches are ready.',
      whatYouSell: 'What do you sell?',
      whatYouSellHelp: 'One sentence: your product or service.',
      audience: 'Target audience',
      audienceHelp: 'Who buys? Role, company size, need.',
      industry: 'Target industry',
      country: 'Target country',
      city: 'Target city (optional)',
      website: 'Website (optional)',
      meetingLink: 'Meeting link (Calendly etc. — optional)',
      submit: 'Save and see companies',
      success: 'Profile saved. Fetching matching companies…',
      selectOption: 'Select…',
    },
    discover: {
      title: 'Companies that match you',
      sub: '{count} companies in Mife\'s database match your criteria. Unlock contacts to reveal email + details.',
      filterIndustry: 'Industry',
      filterCountry: 'Country',
      filterCity: 'City',
      filterApply: 'Filter',
      filterClear: 'Clear',
      colCompany: 'Company',
      colContact: 'Contact',
      colLocation: 'Location',
      colSize: 'Size',
      colAction: 'Action',
      reveal: 'Unlock contact',
      revealed: 'Unlocked',
      selected: 'Selected',
      emptyTitle: "We couldn't find exact matches",
      emptyBody: 'Here are similar companies you can explore:',
      openDashboard: 'My Campaign',
      previewBanner: "You're previewing 5 contacts on Free. Upgrade for unlimited discovery.",
    },
    dashboard: {
      title: 'My Campaign',
      sub: 'Companies you unlocked and their status.',
      contactsRemaining: 'Contacts left',
      emailsRemaining: 'AI emails left',
      icpBox: 'AI Ideal Customer Profile',
      icpEmpty: 'No ICP generated yet.',
      icpGenerate: 'Generate ICP',
      icpRegenerate: 'Regenerate',
      goDiscover: 'Find more companies',
      leadsTitle: 'Your companies',
      leadsEmpty: 'No companies yet. Click "Find more companies".',
      colCompany: 'Company',
      colContact: 'Contact',
      colStatus: 'Status',
      colActions: 'Actions',
      genEmails: 'Generate AI email',
      view: 'View',
      delete: 'Delete',
      statusOptions: {
        selected: 'Selected',
        draft_ready: 'Emails ready',
        contacted: 'Contacted',
        replied: 'Replied',
        meeting: 'Meeting',
      },
      drafts: 'AI Email Drafts',
      noDrafts: 'No drafts yet. Click "Generate AI email".',
      copy: 'Copy',
      upgrade: 'Upgrade Plan',
      urgency: 'Limited free usage — upgrade to continue.',
    },
    pricing: {
      h1: 'Continuous strategic intelligence.',
      sub: 'Not a one-off report — an operational intelligence subscription that tracks how your company actually evolves. Cancel anytime.',
      mostPopular: 'Most chosen',
      perMonth: '/month',
      free:    { name: 'Free',    price: '€0',  tagline: 'Run your first diagnostic.' },
      starter: { name: 'Starter', price: '€29', tagline: 'For operators building visibility into growth constraints.' },
      pro:     { name: 'Pro',     price: '€79', tagline: 'For teams running continuous operational reassessments.' },
      cta: 'Choose plan',
      ctaCurrent: 'Current plan',
      footnote: 'GDPR-aligned. Your data stays yours. Cancel anytime.',
      legal: 'Privacy · Terms · Imprint · DPA',
    },
    paywall: {
      title: "You've reached your free limit.",
      body: 'Upgrade to continue:',
      bullet1: 'Unlimited lead discovery',
      bullet2: 'Full contact access',
      bullet3: 'AI-powered outreach',
      cta: 'Upgrade Now',
      cancel: 'Not now',
      socialProof: 'Built for founders, agencies and sales teams.',
      weeklyProof: 'Find leads, generate outreach, and close faster',
    },
  },
  de: {
    nav: {
      home: 'Startseite',
      pricing: 'Preise',
      lifeAssistant: 'Life Assistant',
      salesAi: 'Sales AI',
      login: 'Anmelden',
      cta: 'Jetzt Kunden finden',
    },
    landing: {
      eyebrow: 'AI Sales Assistant',
      h1Primary: 'Mehr Kunden. Weniger Aufwand.',
      h1Pre: 'Mife liefert dir',
      h1Highlight: 'kontaktbereite Unternehmen',
      h1Post: '— die KI übernimmt das Outreach.',
      sub: 'Du musst keine eigenen Leads mitbringen. Wähle Branche und Zielmarkt, wähle aus Mifes kuratierter Datenbank die Unternehmen, die du ansprechen willst, und die KI schreibt personalisierte E-Mails für dich.',
      ctaPrimary: 'Jetzt Kunden finden',
      ctaSecondary: 'Preise ansehen',
      trust: 'Kostenlos starten · Keine Kreditkarte · Jederzeit kündbar',
      featuresTitle: 'In drei Schritten zur Sales-Pipeline',
      f1Title: '1 — Zielmarkt wählen',
      f1Body: 'Branche, Land, optional Stadt. Passende Unternehmen erscheinen sofort aus Mifes Datenbank.',
      f2Title: '2 — Unternehmen entsperren',
      f2Body: 'Entsperre jeden Kontakt. E-Mail-Adresse und Details werden sichtbar.',
      f3Title: '3 — KI schreibt, du sendest',
      f3Body: 'Drei personalisierte E-Mail-Varianten pro Kontakt. Versand erfolgt im nächsten Schritt über dein eigenes Gmail.',
      whyTitle: 'Warum Mife Sales AI?',
      why: [
        { t: 'Datenbank schon da', d: 'Kein Listen-Jagen mehr. Mife liefert tausende B2B-Kontakte in einer Konsole.' },
        { t: 'Ein Tool, 3 Sprachen', d: 'Outbound-Nachrichten auf Deutsch, Englisch und Türkisch aus derselben Konsole.' },
        { t: 'Deine eigene Domain', d: 'Versand über dein Gmail/Workspace. Markenvertrauen bleibt bei dir.' },
        { t: 'System statt Spam', d: 'Tageslimit, KI-Personalisierung und Pausen zwischen Sendungen sind eingebaut.' },
      ],
      complianceTitle: 'DSGVO-konforme Architektur',
      complianceBody:
        'E-Mails werden über dein eigenes Gmail-Konto verschickt. Mife stellt nur das Tool. Daten bleiben auf EU-Servern, werden nicht verkauft und nicht zum Training externer Modelle genutzt.',
      bottomCtaTitle: 'Wähle heute deine ersten 10 Unternehmen aus Mife.',
      bottomCtaBody: 'Onboarding in 2 Minuten. Erste personalisierte E-Mails in 5.',
    },
    onboarding: {
      title: 'Sales AI Onboarding',
      sub: 'Drei Fragen — und wir laden deine passenden Unternehmen.',
      whatYouSell: 'Was verkaufst du?',
      whatYouSellHelp: 'Ein Satz: dein Produkt oder Service.',
      audience: 'Zielgruppe',
      audienceHelp: 'Wer kauft? Rolle, Firmengröße, Bedarf.',
      industry: 'Zielbranche',
      country: 'Zielland',
      city: 'Zielstadt (optional)',
      website: 'Website (optional)',
      meetingLink: 'Meeting-Link (Calendly etc. — optional)',
      submit: 'Speichern und Unternehmen anzeigen',
      success: 'Profil gespeichert. Passende Unternehmen werden geladen…',
      selectOption: 'Auswählen…',
    },
    discover: {
      title: 'Passende Unternehmen für dich',
      sub: '{count} Unternehmen in Mifes Datenbank passen zu deinen Kriterien. Entsperre Kontakte für E-Mail + Details.',
      filterIndustry: 'Branche',
      filterCountry: 'Land',
      filterCity: 'Stadt',
      filterApply: 'Filtern',
      filterClear: 'Zurücksetzen',
      colCompany: 'Unternehmen',
      colContact: 'Kontakt',
      colLocation: 'Standort',
      colSize: 'Größe',
      colAction: 'Aktion',
      reveal: 'Kontakt entsperren',
      revealed: 'Entsperrt',
      selected: 'Ausgewählt',
      emptyTitle: 'Keine exakten Treffer',
      emptyBody: 'Hier sind ähnliche Unternehmen, die du erkunden kannst:',
      openDashboard: 'Meine Kampagne',
      previewBanner: 'Du siehst 5 Kontakte im Free-Plan. Upgrade für unbegrenzte Suche.',
    },
    dashboard: {
      title: 'Meine Kampagne',
      sub: 'Entsperrte Unternehmen und ihre Status.',
      contactsRemaining: 'Verbleibende Kontakte',
      emailsRemaining: 'Verbleibende KI-Mails',
      icpBox: 'KI Ideal Customer Profile',
      icpEmpty: 'Noch kein ICP erstellt.',
      icpGenerate: 'ICP erstellen',
      icpRegenerate: 'Neu erstellen',
      goDiscover: 'Weitere Unternehmen finden',
      leadsTitle: 'Deine Unternehmen',
      leadsEmpty: 'Noch keine Unternehmen. Klicke „Weitere Unternehmen finden".',
      colCompany: 'Unternehmen',
      colContact: 'Kontakt',
      colStatus: 'Status',
      colActions: 'Aktionen',
      genEmails: 'KI-Mail erstellen',
      view: 'Anzeigen',
      delete: 'Löschen',
      statusOptions: {
        selected: 'Ausgewählt',
        draft_ready: 'E-Mails bereit',
        contacted: 'Kontaktiert',
        replied: 'Geantwortet',
        meeting: 'Meeting',
      },
      drafts: 'KI E-Mail-Entwürfe',
      noDrafts: 'Noch keine Entwürfe. Klicke „KI-Mail erstellen".',
      copy: 'Kopieren',
      upgrade: 'Plan upgraden',
      urgency: 'Begrenzte Free-Nutzung — upgrade, um fortzufahren.',
    },
    pricing: {
      h1: 'Kontinuierliche strategische Intelligenz.',
      sub: 'Kein einmaliger Report — ein operatives Intelligenz-Abo, das verfolgt, wie sich dein Unternehmen tatsächlich entwickelt. Jederzeit kündbar.',
      mostPopular: 'Am häufigsten gewählt',
      perMonth: '/Monat',
      free:    { name: 'Free',    price: '€0',  tagline: 'Erste Diagnose ausführen.' },
      starter: { name: 'Starter', price: '€29', tagline: 'Für Operator:innen, die Sichtbarkeit auf Wachstumsengpässe aufbauen.' },
      pro:     { name: 'Pro',     price: '€79', tagline: 'Für Teams, die kontinuierliche operative Neubewertungen fahren.' },
      cta: 'Plan wählen',
      ctaCurrent: 'Aktueller Plan',
      footnote: 'DSGVO-konform. Deine Daten bleiben deine. Jederzeit kündbar.',
      legal: 'Datenschutz · AGB · Impressum · AVV',
    },
    paywall: {
      title: 'Du hast dein Free-Limit erreicht.',
      body: 'Upgrade, um fortzufahren:',
      bullet1: 'Unbegrenzte Lead-Suche',
      bullet2: 'Voller Kontaktzugang',
      bullet3: 'KI-gestütztes Outreach',
      cta: 'Jetzt upgraden',
      cancel: 'Nicht jetzt',
      socialProof: 'Für Gründer, Agenturen und Sales-Teams gebaut.',
      weeklyProof: 'Leads finden, Outreach erstellen, schneller abschließen',
    },
  },
};

// Detect language for the Sales surface from the URL prefix.
//   /de/sales*  -> 'de'
//   /en/sales*  -> 'en'
//   anything else -> 'tr'
export function detectSalesLang(pathname) {
  if (!pathname) return 'tr';
  if (pathname === '/de' || pathname.startsWith('/de/')) return 'de';
  if (pathname === '/en' || pathname.startsWith('/en/')) return 'en';
  return 'tr';
}

export function localizeSalesPath(lang, suffix = '') {
  const clean = suffix.startsWith('/') ? suffix : suffix ? `/${suffix}` : '';
  if (lang === 'de') return `/de/sales${clean}`;
  if (lang === 'en') return `/en/sales${clean}`;
  return `/sales${clean}`;
}

// Maps to the Mife main homepage (Life Assistant landing) in the user's language.
//   tr -> /     en -> /en     de -> /de
// (All three routes render the LandingPage component; /de is a temporary alias
// that uses EN i18n until we ship a fully German Life Assistant landing.)
export function localizeMainPath(lang) {
  if (lang === 'de') return '/de';
  if (lang === 'en') return '/en';
  return '/';
}
